/**
 * mSTEM mock robot fleet (DG-11/DG-12). Used as the seed for robotsReducer
 * initial state. BE team will replace this import with an API call to a
 * real robot inventory endpoint.
 *
 * Each entry: {id, name, type, firmwareVersion, connectionStatus, image, brand}
 *   id               — kebab-case slug, primary key
 *   name             — display name, brand-fixed (not translated)
 *   type             — matches lib/libraries/devices/<id> folder name
 *                      (used for code generator routing later)
 *   firmwareVersion  — semver-ish string; latest installed
 *   connectionStatus — one of 'ready' | 'outdated' | 'beta'
 *   image            — null until DFT provides product photos (DG-21)
 *   brand            — manufacturer string
 */

const ROBOTS = [
    {
        id: 'mbf-robot-v1',
        name: 'MBF Robot v1',
        type: 'arduinoUno',
        firmwareVersion: '1.0.3',
        connectionStatus: 'ready',
        image: null,
        brand: 'MBF'
    },
    {
        id: 'mbf-smart-car-pro',
        name: 'MBF Smart Car Pro',
        type: 'esp32',
        firmwareVersion: '2.1.0',
        connectionStatus: 'ready',
        image: null,
        brand: 'MBF'
    },
    {
        id: 'mbf-mini-bot',
        name: 'MBF Mini Bot',
        type: 'microbitV2',
        firmwareVersion: '1.5.2',
        connectionStatus: 'outdated',
        image: null,
        brand: 'MBF'
    },
    {
        id: 'mbf-ai-camera-bot',
        name: 'MBF AI Camera Bot',
        type: 'esp32S3',
        firmwareVersion: '1.0.0-beta',
        connectionStatus: 'beta',
        image: null,
        brand: 'MBF'
    },
    {
        id: 'mbf-lab-trainer',
        name: 'MBF Lab Trainer',
        type: 'raspberryPiPico',
        firmwareVersion: '3.0.1',
        connectionStatus: 'ready',
        image: null,
        brand: 'MBF'
    }
];

export default ROBOTS;
